import React from 'react';
import '../../css/AboutUs.css';

function AboutUs() {
    return (
        <div className="aboutus-container">
            <h1>About Us</h1>

            <h2>Mentium.pro: The Relationship Marketplace for Real Estate Professionals</h2>

            <p>At Mentium.pro, we’re redefining how real estate professionals connect, collaborate, and succeed.
                Our platform isn’t just about transactions—it’s about building meaningful, long-term partnerships between Realtors and top-tier service providers.</p>

            <h2>A Community Built for Mutual Success</h2>
            <p>Mentium.pro is more than a marketplace; it’s a thriving ecosystem where Realtors and service companies grow together.
                We curate connections based on trust, expertise, and shared goals, fostering an environment where quality partnerships drive business forward.</p>

            <h2>No Leads—Just Real Relationships</h2>
            <p>Tired of chasing leads? So are we. Mentium.pro moves beyond the traditional lead-selling model, focusing instead on genuine, lasting relationships that create real value for everyone involved.
                We connect professionals committed to mutual success, helping them build networks that fuel long-term growth.</p>

            <h2>Join Mentium.pro Today</h2>
            <p>Discover the power of a well-connected community. Join Mentium.pro and experience a more innovative way to collaborate, grow, and succeed in real estate.</p>
        </div>
    );
}

export default AboutUs;
